import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.5px] transition-colors",
  {
    variants: {
      // Darker text colors maintain WCAG 2.2 AA 4.5:1 contrast ratio on tinted backgrounds.
      variant: {
        default: "bg-[var(--accent-weak)] text-[#1044a0]",
        success: "bg-[rgba(26,138,82,0.08)] text-[#0d6e3e]",
        warn: "bg-[rgba(196,138,26,0.10)] text-[#7a5200]",
        danger: "bg-[rgba(196,58,42,0.08)] text-[#a02d1f]",
        muted: "bg-[rgba(0,0,0,0.05)] text-[var(--muted)]",
        outline: "border border-[var(--border)] text-[var(--fg)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps): React.JSX.Element {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
